/*
 *   File : delete-mandate.js
 *   Author URI : https://evoqins.com
 *   Description : Delete Mandate Confirmation Modal
 *   Integrations : null
 *   Version : v1.2
 */

import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { GradientButton, SecondaryButton } from "../Cta";
import Icon from "../Icon/icon";
import { OTPInput } from "../FormElements";
import style from "../../Styles/Components/unlock.module.scss";
import { toast } from "react-toastify";

const DeleteMandate = (props) => {

    const [pinString, setPinString] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [buttonLoader, setButtonLoader] = useState(false);
    const [seconds, setSeconds] = useState(30);

    /* Modal close listener */
    useEffect(() => {
        const my_modal = document.getElementById("delete-mandate");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
            setPinString('');
        });
    }, []);

    /* Reset timer on modal show */
    useEffect(() => {
        const my_modal = document.getElementById("delete-mandate");
        my_modal.addEventListener("shown.bs.modal", () => {
            setSeconds(29);
        });
    }, []);

    /* Countdown timer for resend OTP */
    useEffect(() => {
        const countdown = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            } else {
                clearInterval(countdown);
            }
        }, 1000);

        return () => clearInterval(countdown);
    }, [seconds]);

    /* Handle OTP input change */
    const _handlePin = (value) => {
        setPinString(value);
        setErrorMessage("");
    };

    /* Handle resend OTP click - handled by parent via props */
    function _handleResend() {
        if (props.onResend) {
            props.onResend(); // trigger parent's resend logic
        }
        setPinString("");
        setSeconds(30);
    }

    /* Verify OTP and confirm deletion */
    async function _verifyPin() {
        if (pinString.length !== 4) {
            setErrorMessage("Please enter the 4-digit verification code");
            return;
        }

        setButtonLoader(true);

        if (props.onVerify) {
            props.onVerify(pinString);
        }

        setButtonLoader(false);
    }

    return (
        <div
            id="delete-mandate"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-hidden="true"
            className={`modal fade ${style.e_unlock}`}
        >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content padding-32px-all ${style.e_content}`}>
                    <button className="d-none" data-bs-dismiss="modal" id="close-modal"></button>

                    <div className="col-12 d-flex justify-content-between">
                        <Icon
                            icon="close"
                            size={24}
                            className="cursor-pointer ms-auto e-modal-close-btn"
                            data-bs-dismiss="modal"
                        />
                    </div>

                    <img
                        draggable={false}
                        src={require("../../Assets/Images/Modal/pin_illustration.png")}
                        alt="Mandate deletion"
                        width={72}
                        height={72}
                        className="mx-auto"
                    />

                    <h6 className="color-eerie-black e-poppins-medium e-font-18 mt-4 mb-0 text-center">
                        {props.type === 1 ? 'Confirm Bank Deletion' : 'Confirm Mandate Deletion'}
                    </h6>
                    <p className="color-outer-space e-poppins-regular e-font-14 mt-2 mb-0 px-5 letter-spacing-point28 text-center">
                        {props.type === 1
                            ? ' To delete this bank, please enter the OTP sent to your registered email and mobile number.'
                            : ' To delete this mandate, please enter the OTP sent to your registered email and mobile number.'
                        }

                    </p>

                    <div className="d-flex flex-column align-items-center text-start mt-3 mb-2">
                        <OTPInput
                            pinString={pinString}
                            id="mandate-otp"
                            autoFocus={true}
                            pinError={errorMessage}
                            disabled={buttonLoader}
                            handleChange={_handlePin}
                        />
                    </div>

                    <div className="d-flex justify-content-center mt-4 w-100">
                        <SecondaryButton
                            label="Cancel"
                            className="padding-12px-tb e-font-16"
                            cancel="modal"
                        />
                        <GradientButton
                            label={props.type === 1 ? "Confirm Delete Bank" : "Confirm Delete Mandate"}
                            loading={buttonLoader}
                            className="padding-12px-tb e-font-16 ms-3"
                            onPress={_verifyPin}
                        />
                    </div>

                    <div className="d-flex justify-content-center mt-4">
                        {seconds === 0 ? (
                            <p
                                className="color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-pointer mb-0 e-forgot-pin position-relative w-max-content resend"
                                onClick={_handleResend}
                            >
                                Resend OTP
                            </p>
                        ) : (
                            <p className="color-primary-color e-poppins-regular e-font-14 line-height-14px cursor-not-allowed mb-0">
                                Resend OTP in <span className="color-black">{seconds}s</span>
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteMandate;
